$(document).ready(function()
{

  var acc = document.getElementsByClassName("toggleTitle");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      this.classList.toggle("arrow-open");
      var toggleContent = this.nextElementSibling;
      if (toggleContent.style.display === "block") {
        toggleContent.style.display = "none";
      } else {
        toggleContent.style.display = "block";
      }
    });
  }
})

function navigationMenuSection(){
  const navigationMenus = document.querySelectorAll('.navigation-menu');
  console.log('navigationMenus', navigationMenus);

  navigationMenus.forEach(item => {
      const menuTrigger = item.querySelector('.mobile-menu-trigger');

      menuTrigger.addEventListener('click', () => {
        console.log('click insection-blocks__accordion-item ')
        navigationMenus.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
          }
        });

        item.classList.toggle('active');
      });
  });
}

document.addEventListener('DOMContentLoaded', (evt) => {
  navigationMenuSection();

  var isSafari = /^Apple/.test(navigator.vendor) && !/CriOS|FxiOS/.test(navigator.userAgent);
  
  if (isSafari) {
      document.querySelector('body').classList.add('is-safari');
  }
})

// Fix PDP Button on scroll
function addtoCartCheckScroll() {
  var scrollPosition = window.scrollY;
  var PDPaddtoCartForm = document.querySelector("body:not(.suffix-personalization) .block-buy-buttons.block-buy-buttons.product-block");
  
  if (PDPaddtoCartForm) {
      var elementOffset = PDPaddtoCartForm.getBoundingClientRect().top + window.scrollY;
      var distance = elementOffset + 50; // 50px below the element

      if (scrollPosition > distance) {
        PDPaddtoCartForm.classList.add("make-fix");
      } else {
        PDPaddtoCartForm.classList.remove("make-fix");
      }
  }
}
function addtoCartBlockClickWhenFixed( ele ) {

  
}

window.addEventListener("scroll", addtoCartCheckScroll);

var PDPaddtoCartBtn = document.querySelector(".block-buy-buttons.block-buy-buttons.product-block button");

if(PDPaddtoCartBtn){
  PDPaddtoCartBtn.addEventListener("click", function( event ){
    var PDPaddtoCartForm = PDPaddtoCartBtn.closest(".block-buy-buttons.product-block");
  
    if(PDPaddtoCartForm && PDPaddtoCartForm.classList.contains('make-fix')){
      event.preventDefault();
  
      if (PDPaddtoCartForm) {
        document.querySelector('.product-grid__content.product--description').scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  
  });
}

/* GCW Recs: scroll controls + Quick Add (modal-first with single-variant fast add) + auto-bind */
(function () {
  const doc = document;
  const $ = (s, r = doc) => r.querySelector(s);

  const modal  = $('#QuickAddModal');
  const holder = $('#QuickAddHolder');

  function openModal() {
    if (!modal) return;
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('modal-open');
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('modal-open');
    if (holder) holder.innerHTML = '';
  }

  doc.addEventListener('click', (e) => {
    if (e.target.closest('.js-modal-close')) { e.preventDefault(); closeModal(); }
    if (e.target === modal) closeModal();
  });
  doc.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal?.classList.contains('is-active')) closeModal();
  });

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('Product JSON failed');
    return res.json();
  }
  function firstAvailableVariant(product) {
    return product?.variants?.find(v => v && v.available) || product?.variants?.[0];
  }
  /* === CHANGED: helper to decide fast-add === */
  function isSingleVariantPurchasable(product) {
    return !!(product && Array.isArray(product.variants) &&
              product.variants.length === 1 &&
              product.variants[0] && product.variants[0].available);
  }

  async function addToCart(variantId, qty = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty, sections: 'cart-ajax' })
    });
    if (!res.ok) throw await res.json();
    return res.json();
  }
  function tryOpenDrawer(detail) {
    try { if (window.theme?.cart?.openDrawer) { window.theme.cart.openDrawer(detail); return; } } catch(e){}
    try { if (window.Shopify?.theme?.cart?.showDrawer) { window.Shopify.theme.cart.showDrawer(detail); return; } } catch(e){}
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail }));
    document.dispatchEvent(new CustomEvent('ajaxProductAdded', { bubbles: true, detail: { product: detail } }));
  }

  async function hydrateQuickAdd({ handle, productId, title }) {
    if (!holder) return;
    holder.innerHTML = '<div class="quick-add__loading" aria-live="polite">Loading…</div>';

    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}?view=quick-add`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('quick-add view not found');
      const html = await res.text();
      holder.innerHTML = `
        <div class="tool-tip quick-add-modal" data-product-id="${productId || ''}" data-product-title="${title || ''}">
          ${html}
        </div>
      `;
      return;
    } catch (err) {
      try {
        const product = await fetchProduct(handle);
        const first = firstAvailableVariant(product);
        holder.innerHTML = `
          <div class="tool-tip quick-add-modal" data-product-id="${productId || ''}" data-product-title="${title || ''}">
            <h3 class="quick-add__title">${product.title}</h3>
            ${product.variants.length > 1
              ? `<p>Select options on the product page.</p>
                 <a class="btn" href="/products/${product.handle}">View product</a>`
              : `<form id="gcw-qa-fallback" class="quick-add__form">
                   <input type="hidden" name="id" value="${first?.id || ''}">
                   <button type="submit" class="btn">Add to cart</button>
                 </form>`
            }
          </div>
        `;
        const fb = $('#gcw-qa-fallback', holder);
        if (fb) {
          fb.addEventListener('submit', async (e) => {
            e.preventDefault();
            const id = fb.querySelector('input[name="id"]')?.value;
            if (!id) return;
            try {
              const detail = await addToCart(Number(id), 1);
              tryOpenDrawer(detail);
              closeModal();
            } catch (e2) {
              console.warn('Fallback add failed', e2);
            }
          });
        }
      } catch (e2) {
        holder.innerHTML = `<p class="quick-add__error">Sorry, something went wrong.</p>`;
      }
    }
  }

  function init(container) {
    if (!container || container.dataset.gcwRecsBound) return;

    const scroller = container.querySelector('.gcw-recs__scroller');
    if (scroller) {
      const prev = container.querySelector('.gcw-recs__prev');
      const next = container.querySelector('.gcw-recs__next');
      const item = scroller.querySelector('.gcw-recs__item, .grid-item');
      const gap = () => { const cs = getComputedStyle(scroller); return parseFloat(cs.columnGap || cs.gap || 0) || 0; };
      const step = () => { const w = item ? item.getBoundingClientRect().width : scroller.clientWidth * 0.8; return w + gap(); };
      const updateArrows = () => {
        const maxLeft = scroller.scrollWidth - scroller.clientWidth - 1;
        const l = scroller.scrollLeft;
        if (prev) prev.disabled = l <= 0;
        if (next) next.disabled = l >= maxLeft;
      };
      prev && prev.addEventListener('click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => scroller.scrollBy({ left:  step(), behavior: 'smooth' }));
      scroller.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { scroller.scrollLeft += e.deltaY; e.preventDefault(); }
      }, { passive: false });
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      updateArrows();
    }

    container.addEventListener('click', async function(e) {
      const btn = e.target.closest('.js-modal-open-quick-add, .js-quick-add-open, .js-br-quick-add, .quick-add-btn');
      if (!btn || !container.contains(btn)) return;

      e.preventDefault();
      e.stopPropagation();

      const handle    = btn.dataset?.handle;
      const productId = btn.dataset?.productId || '';
      const title     = btn.dataset?.productTitle || btn.getAttribute('aria-label') || '';
      if (!handle) return;

      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      try {
        /* === CHANGED: prefer fast add when exactly one available variant === */
        const product = await fetchProduct(handle);
        if (isSingleVariantPurchasable(product)) {
          const detail = await addToCart(product.variants[0].id, 1);
          tryOpenDrawer(detail);
          btn.classList.add('is-added');
          setTimeout(() => btn.classList.remove('is-added'), 800);
        } else if (modal && holder) {
          openModal();
          await hydrateQuickAdd({ handle, productId, title });
        } else {
          // No modal available: add first available variant
          const variantId = firstAvailableVariant(product)?.id;
          if (!variantId) throw new Error('No variant');
          const detail = await addToCart(variantId, 1);
          tryOpenDrawer(detail);
        }
      } catch (err) {
        console.error(err);
        document.dispatchEvent(new CustomEvent('gcw:quickAdd:error', { detail: { handle, error: err } }));
      } finally {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }, { passive: false });

    container.dataset.gcwRecsBound = '1';
  }

  function scan(root = document) { root.querySelectorAll('.gcw-recs').forEach(init); }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', () => scan());
  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => scan(e.target));

  let t;
  const mo = new MutationObserver(() => { clearTimeout(t); t = setTimeout(scan, 50); });
  mo.observe(document.body, { childList: true, subtree: true });
})();